import { Navigate } from "react-router-dom";
import { canAccessRoute, getDefaultHomePath } from "utils/routeAccess";

function ProtectedRoute({ route, children }) {
  if (route?.roles && !canAccessRoute(route)) {
    const home = getDefaultHomePath();
    if (route.route === home) {
      return <Navigate to="/login" replace />;
    }
    return <Navigate to={home} replace />;
  }
  return children;
}

export default ProtectedRoute;
